import dayjs from 'dayjs'
import 'dayjs/locale/el'
import TruncateDescription from "../../pages/dashboard/partials/truncateDescription";

export const getMonthName = (year, month) =>
    dayjs(`${year}-${month}-01`).locale('el').format('MMMM')

export const buildDynamicColumns = (data, { includeKeys = [], locale = 'el', thousandSeparator = '.', decimalSeparator = ',', label = ''} = {}) => {
    if (!data || data.length === 0) return []

    const firstRow = data[0]
    const availableKeys = Object.keys(firstRow)

    const filteredKeys = availableKeys.filter(key =>
        includeKeys.some(prefix => key.startsWith(`${prefix}_`))
    )

    const columns = filteredKeys.map((key) => {
        const [, year, month] = key.split('_') // π.χ. pct_2025_6
        const monthName = dayjs(`${year}-${month}-01`).locale(locale).format('MMMM')

        return {
            field: key,
            headerName: !label ? `${monthName} ${year}` : `${label} ${monthName} ${year}`,
            description: `${monthName} ${year}`,
            flex: 1,
            align: 'right',
            minWidth: 130,
            renderCell: ({ row }) => row[key] === null ? '-' : row[key]
        }
    })

    return columns
}

export const buildDynamicColumnsFromFilters = (filtersData, config, t) => {
    return config
        .filter(({ filterKey }) => {
            const value = filtersData[filterKey]
            return Array.isArray(value) ? value.length > 0 : !!value
        })
        .map(({ field, label, descriptionField }) => ({
            field,
            headerName: t(label),
            description: t(label),
            minWidth: 160,
            flex: 1,
            renderCell: ({ row }) => {
                const value = descriptionField ? row[descriptionField] : row[field]
                return <TruncateDescription value={ value || '-'}/>
            }
        }))
}





